module.exports = __webpack_public_path__ + "img/1548609754.1dadd236.jpg";